import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id E7CCD9CF-3FC1-44F0-996B-841B293B1793
 * name music-rest-sixteenth
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/music-rest-sixteenth.svg
 * tags
 * - Music 
 */
export const MusicRestSixteenthIcon = createSvgIcon(<><path d="M15 3A5.56 5.56 0 0 1 11.95 4.86A1.5 1.5 0 1 0 10.5 6H10.74A6.32 6.32 0 0 0 14.25 4.93L12.9 9.1A5.56 5.56 0 0 1 9.95 10.86A1.5 1.5 0 1 0 8.5 12H8.74A6.32 6.32 0 0 0 12.25 10.93L9 21H11L17 3Z" /></>, 'MusicRestSixteenthIcon');
export default MusicRestSixteenthIcon